module.exports = __webpack_public_path__ + "static/img/filter.58dc32a7.svg";